import React from 'react'
import { createComponent } from 'react-fela'
import PropTypes from 'prop-types'

import Spinner from 'bms-web-components/src/modules/spinner'
import { __loaderInnerWrap } from './__style'

const LoaderInnerWrap = createComponent(__loaderInnerWrap)

/**
    Use centerAt = 'fixed' prop to center the loader in middle of the page
    Use centerAt = 'inherited' prop to center the loader in middle of the container
*/

const Loader = ({ active, centerAt }) =>
	active ? (
		<LoaderInnerWrap centerAt={centerAt}>
			<Spinner />
		</LoaderInnerWrap>
	) : null

Loader.defaultProps = {
	centerAt: 'fixed',
}

Loader.propTypes = {
	/** To center spinning loader based on value provided */
	centerAt: PropTypes.string,
}

export default Loader
